module.exports = __webpack_public_path__ + "static/media/bg_programme.9f60d11c.png";